<nav mat-tab-nav-bar class="easy-tab" [tabPanel]="tabPanel">
  <ng-container *ngFor="let link of navLinks">
    <a
      mat-tab-link
      [routerLink]="baseUrl + link.link"
      [replaceUrl]="true"
      [queryParams]="queryParams"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="activeLinkIndex === link.index"
    >
      {{ link.label | translate }}
    </a>
  </ng-container>
</nav>
